/**
 * Modal global elegante — substitui os toasts (sonner) e os alert()/confirm() nativos.
 *
 * API imperativa (estilo `toast`, pode ser chamada de qualquer lugar, inclusive fora de componente):
 *   modal.success("Salvo com sucesso")
 *   modal.success({ title: "Tudo certo!", message: "...", details: ["linha 1", {label:"Total", value:"42"}] })
 *   modal.error(apiError(e))
 *   modal.info("...")  ·  modal.warning("...")
 *   const ok = await modal.confirm({ title, message, confirmText, cancelText, tone: "danger" })  // -> boolean
 *
 * O <ModalHost/> (montado uma única vez na raiz, em App.js) registra o renderizador.
 */
let handler = null;
const queue = [];

function dispatch(type, arg) {
  const payload =
    arg && typeof arg === "object"
      ? { ...arg }
      : { message: arg == null ? "" : String(arg) };
  payload.type = type;
  return new Promise((resolve) => {
    const item = { payload, resolve };
    if (handler) handler(item);
    else queue.push(item); // guarda chamadas feitas antes do host montar
  });
}

export const modal = {
  success: (a) => dispatch("success", a),
  error: (a) => dispatch("error", a),
  info: (a) => dispatch("info", a),
  warning: (a) => dispatch("warning", a),
  confirm: (a) => dispatch("confirm", a),
};

// Registrado pelo <ModalHost/>. Retorna função de cleanup.
export function __registerModalHandler(fn) {
  handler = fn;
  if (fn) {
    while (queue.length) fn(queue.shift());
  }
  return () => {
    if (handler === fn) handler = null;
  };
}

export default modal;
